import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
const CallbackContext = /*#__PURE__*/ createContext(null);
const useAdditionalFetchDataHelpersPluginCallback = ()=>useContext(CallbackContext);
const AdditionalFetchDataHelpersPlugin = ({ getAttachmentUrl, searchMentions, children })=>{
    const [editor] = useLexicalComposerContext();
    useEffect(()=>{
        editor._getAttachmentUrl = getAttachmentUrl;
        editor._searchMentions = searchMentions;
    }, [
        editor,
        getAttachmentUrl,
        searchMentions
    ]);
    const contentValue = useMemo(()=>({
            getAttachmentUrl: getAttachmentUrl,
            searchMentions: searchMentions
        }), [
        getAttachmentUrl,
        searchMentions
    ]);
    return /*#__PURE__*/ jsx(CallbackContext.Provider, {
        value: contentValue,
        children: children
    });
};
export { AdditionalFetchDataHelpersPlugin, useAdditionalFetchDataHelpersPluginCallback };
